import * as React from 'react';
import './ProgressWidget.css';
import {
  WidgetWrapper,
  WidgetText,
} from '../core/DashbardGridStyledComponents';
import { withDataFetch } from '../hoc/withDataFetch';

const CircularProgressbar = React.lazy(() =>
  import('react-circular-progressbar').then(module => ({
    default: module.CircularProgressbar,
  }))
);

export interface ProgressWidgetProps {
  data: object;
  options: object;
}
const ProgressWidget: React.FC<any> = ({ data, options }) => {
  const { value } = data;
  const { title, titleClasses } = options;
  return (
    <WidgetWrapper>
      <WidgetText size="large" {...titleClasses}>
        {title}
      </WidgetText>
      <React.Suspense fallback="loading...">
        <CircularProgressbar
          value={value}
          text={`${value}%`}
          className="progress-widget"
        />
      </React.Suspense>
    </WidgetWrapper>
  );
};

export default withDataFetch(ProgressWidget);
